import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';
import { SelfClosingPopup } from 'ui/components';
import { authorize } from 'utils/auth';
import { FormattedMessage } from 'ui/i18n';

@inject('CartState')
@observer
export default class Cart extends Component {
	static propTypes = {
		CartState: PropTypes.object.isRequired,
	};

	CartState = this.props.CartState;

	@action
	togglePopup() {
		this.CartState.addedInCart = false;
	}
	render() {
		return (
			<div className="navbar-controls Header__cart">
				{authorize(['AddToCart'], true, false)
					? <Link to="/cart" className="Header__cart-title">
							<FormattedMessage id="header.yourCart" />
							{!this.CartState.isCartEmpty &&
								<span className="Header__cart-populated">
									{this.CartState.cartLength}
								</span>}
						</Link>
					: <div className="disabled-cart">
							<FormattedMessage id="header.yourCart" />
						</div>}

				<SelfClosingPopup
					show={this.CartState.addedInCart}
					onRequestClose={this.togglePopup.bind(this)}
					className="ItemsAdded"
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Header/Cart.js